import {FC} from 'react';
import style from './style.module.scss';
import {ProductReviewUser} from '../ProductReviewUser';
import {Avatar} from 'components/Avatar';
import {IReview, IReviewAuthor} from 'modules/product-card/models/Review';
import {getMediaSrc} from 'core/helpers/media';
import cs from 'classnames';

interface IProps {
    rate?: number;
    review: IReview;
    author?: IReviewAuthor;
    fullName: string;
}

export const ProductReviewCardHeader: FC<IProps> = ({rate, author, fullName, review}) => {
    const userInitials = author?.userInitials;

    return (
        <div className={cs(style.header, 'product-review-card-header')}>
            <ProductReviewUser fullName={fullName} rate={rate} review={review}>
                <Avatar
                    personalPhoto={getMediaSrc(author?.personalPhoto || '', {height: 100, width: 100})}
                    userInitials={userInitials}
                />
            </ProductReviewUser>
        </div>
    );
};
